import axios from "axios";
import rot from "rot";

export default store => {
  const instance = axios.create({
    baseURL: `https://${process.env.REACT_APP_DATA_HOST}`,
    headers: {
      "mosaic-client-auth": rot(process.env.REACT_APP_MOSAIC_ROT13_KEY, -13),
    },
  });

  let isRefreshing = false;
  let refreshSubscribers = [];

  instance.interceptors.response.use(
    response => {
      return response;
    },
    error => {
      const { config, response: { status } } = error;
      const originalRequest = config;

      if (status === 401 && !originalRequest._retry) {
        if (!isRefreshing) {
          isRefreshing = true;
          store.refreshSession().then(newToken => {
            isRefreshing = false;
            onRefreshed(newToken);
          });
        }

        const retryOrigReq = new Promise((resolve, reject) => {
          subscribeTokenRefresh(token => {
            // replace the expired token and retry
            originalRequest.headers["Authorization"] = `Bearer ${token}`;
            originalRequest._retry = true;

            resolve(axios(originalRequest));
          });
        });

        return retryOrigReq;
      } else {
        return Promise.reject(error);
      }
    }
  );

  function subscribeTokenRefresh(cb) {
    refreshSubscribers.push(cb);
  }

  function onRefreshed(token) {
    refreshSubscribers.map(cb => cb(token));
  }

  return instance;
};



// WEBPACK FOOTER //
// ./src/axios.js